var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v("見つかりませんでした"),_c('br'),_vm._v("URLに間違いがあるようです")])}]

export { render, staticRenderFns }